module.exports = __webpack_public_path__ + "static/P9-69261b1b67f7610d8cea089b5354c691.jpeg";